/**
 * Builds a URL path prefixed with the organization id.
 * `path` should not have a leading slash (e.g. "customer/123/signals").
 */
export function buildOrgPath(orgId: string, path: string = ''): string {
  const cleanPath = path.replace(/^\/+/, '');
  return cleanPath ? `/${orgId}/${cleanPath}` : `/${orgId}`;
}
